module.exports = __webpack_public_path__ + "img/ddg93-2.f8a097b7.png";